module.exports = __webpack_public_path__ + "img/close.7f99f89e.svg";